import { propertyIdSchema, zoneIdSchema } from "@estate-platform/domain/ids";
import { createFileRoute, getRouteApi } from "@tanstack/react-router";

import { useViewer } from "../data/hooks.ts";
import { loadProperty } from "../properties/loaders.ts";
import { ZoneRoute } from "../properties/zone-route.tsx";
import { RecordPending } from "../shell/record-pending.tsx";
import { parameterOrNotFound } from "../shell/route-parameters.ts";
import { NoAccessPage } from "../shell/status-pages.tsx";

import type { ReactElement } from "react";

const route = getRouteApi("/_app/properties/$id/zones/$zoneId");

const Page = (): ReactElement => {
  const viewer = useViewer();
  const { id, zoneId } = route.useParams();
  return viewer === null ? <NoAccessPage /> : <ZoneRoute viewer={viewer} propertyId={id} zoneId={zoneId} />;
};

export const Route = createFileRoute("/_app/properties/$id/zones/$zoneId")({
  params: {
    parse: ({ id, zoneId }) => ({
      id: parameterOrNotFound(propertyIdSchema, id),
      zoneId: parameterOrNotFound(zoneIdSchema, zoneId),
    }),
    stringify: ({ id, zoneId }) => ({ id, zoneId }),
  },
  loader: async ({ context, params }) => loadProperty(context.data, params.id, { zoneId: params.zoneId }),
  pendingComponent: () => <RecordPending lead="none" />,
  component: Page,
});
